import menusApi from './api';

export * from './api';
export default menusApi;
